import "./App.css";
import { useState, useEffect } from "react";
import PrivateRoute from "./PrivateRoute";
import { Redirect, Route, BrowserRouter as Router, Switch } from "react-router-dom";


import Login from "./Pages/Login";
import Restaurants from "./Pages/Restaurant/Restaurants";
import Restaurant from "./Pages/Restaurant/Restaurant";
import Dashboard from "./Pages/DashBoard/Dashboard";
import { is_staff_only } from "./Functionalities/Config";

import Orders from "./Pages/Order/Orders";
import Insights from "./Pages/Insights/Insights";
import ServerHealth from "./Pages/ServerHealth/ServerHealth";
import HomeBanners from "./Pages/HomeBanners/HomeBanners";
import CategoryUmbrellas from "./Pages/CategoryUmbrellas/CategoryUmbrellas";
import BannerSection from "./Pages/HomeBanners/BannerSection";
import Payouts from "./Pages/Payouts/Payouts";
import RiderSettlement from "./Pages/Settlements/RiderSettlement";
import RestaurantSettlement from "./Pages/Settlements/RestaurantSettlement";
import AppUpdates from "./Pages/AppUpdates/AppUpdates";
import RestaurantResponse from "./Pages/RestaurantResponse/RestaurantResponse";
import OrderID from "./Pages/Order/OrderID";
import Customers from "./Pages/Customers/Customers";
import Customer from "./Pages/Customers/Customer";
import Comments from "./Pages/Reviews/Comments";
import Products from "./Pages/Products/Products";
import ProductID from "./Pages/Products/ProductID";
import ForgotPassword from "./Pages/ForgotPassword";
import AddProduct from "./Pages/Products/AddProduct";

import AddCategory from "./Pages/Category/AddCategory";
import AddMenu from "./Pages/Menu/AddMenu";

import Categories from "./Pages/Category/Categories";
import Menu from "./Pages/Menu/Menu";
import CategoryID from "./Pages/Category/CategoryID";
import MenuID from "./Pages/Menu/MenuID";
import EditCategoryByID from "./Pages/Category/EditCategoryByID";

import Variant from "./Pages/Category/Variant/Variant";

//shabeeb changes start
import AddSloat from "./Pages/Sloats/AddSloat";
import Sloats from "./Pages/Sloats/Sloat";
import DeliverySlots from "./Pages/DeliverySlots/DeliverySlots";
//shabeeb changes end

import AddRestaurant from "./Pages/Restaurant/AddRestaurant";
import DeliveryBoys from "./Pages/DeliveryBoys/DeliveryBoys";
import DeliveryBoy from "./Pages/DeliveryBoys/DeliveryBoy";
import AddDeliveryBoy from "./Pages/DeliveryBoys/AddDeliveryBoy";

import Banner from "./Pages/Banners/Banner";
import Banners from "./Pages/Banners/Banners";

import Promocode from "./Pages/PromoCode/Promocode";
import PromocodeEdit from "./Pages/PromoCode/PromocodeEdit";
import PromocodeAdd from "./Pages/PromoCode/PromocodeAdd";
import Managers from "./Pages/Managers/Managers";
import Manager from "./Pages/Managers/Manager";
// import Settings from "./Pages/Configuration/Settings";

import DeliveryboyReports from "./Pages/Reports/DeliveryboyReports";
import RestaurantReports from "./Pages/Reports/RestaurantReports";

import { Alerts } from "./CoreComponents/alertBox/alerts";
import AddManager from "./Pages/Managers/AddManager";
import Orderreports from "./Pages/Reports/Orderreports";
import OrderReportNew from "./Pages/Reports/OrderReportNew";

import Image404 from "./Assets/images/404.png";
import Notification from "./Pages/Notification/Notification";
import Profile from "./Pages/Profile/Profile";
import PasswordResetForShop from "./Pages/Profile/PasswordResetForShop";
import OrderExport from "./Pages/Order/OrderExport";
import { AppContext } from "./Functionalities/AppContext";
import Franchises from "./Pages/Franchise/Franchises";
import Franchise from "./Pages/Franchise/Franchise";
import AddFranchise from "./Pages/Franchise/AddFranchise";
import FranchiseRequest from "./Pages/FranchiseRequest/franchiseRequest";

import MobileLandingPage from "./Pages/mobileLandingPage/MobileLandingPage";
import Sections from "./Pages/Sections/Sections";
import Section from "./Pages/Sections/Section";
import AddSection from "./Pages/Sections/AddSection";
import EditSection from "./Pages/Sections/EditSection";
import Settings from "./Pages/Configuration/Settings";
import ProductOffers from "./Pages/ProductOffers/ProductOffer";
import Wallet from "./Pages/Wallet/wallet";
import TestPage from "./Pages/TestPage";
import { startSessionWatcher } from "./Functionalities/sessionManager";

function App() {
  const [newOrder, setNewOrder] = useState({});
  const [NewOrders, setNewOrders] = useState(false);

  useEffect(() => {
    return startSessionWatcher();
  }, []);

  return (
    <div>
      <AppContext.Provider
        value={{ NewOrders, setNewOrders, newOrder: [newOrder, setNewOrder] }}
      >
        <Alerts />
        <Router>
          <Switch>
            {/* <PrivateRoute path="/dashboard"> <Dashboard /> </PrivateRoute> */}
            <PrivateRoute path="/restaurants">
              <Restaurants />
            </PrivateRoute>
            <PrivateRoute path="/restaurant/:id">
              <Restaurant />
            </PrivateRoute>
            <PrivateRoute path="/addrestaurant">
              <AddRestaurant />
            </PrivateRoute>

            <PrivateRoute path="/franchises">
              {" "}
              <Franchises />{" "}
            </PrivateRoute>
            <PrivateRoute path="/franchise/:id">
              <Franchise />
            </PrivateRoute>
            <PrivateRoute path="/addfranchise">
              <AddFranchise />
            </PrivateRoute>

            <Route path="/login">
              <Login />
            </Route>
            {/* <PrivateRoute exact path="/"><DragAndDrop /></PrivateRoute> */}
            <PrivateRoute exact path="/">
              {is_staff_only ? <Redirect to="/orders" /> : <Dashboard />}
            </PrivateRoute>

            <PrivateRoute path="/sections">
              <Sections />
            </PrivateRoute>
            <PrivateRoute path="/section/:id">
              <Section />
            </PrivateRoute>
            <PrivateRoute path="/edit-section">
              <EditSection />
            </PrivateRoute>
            <PrivateRoute path="/add-section">
              <AddSection />
            </PrivateRoute>

            <PrivateRoute path="/insights">
              <Insights />
            </PrivateRoute>
            <PrivateRoute path="/server-health">
              <ServerHealth />
            </PrivateRoute>
            <PrivateRoute exact path="/home-banners">
              <HomeBanners />
            </PrivateRoute>
            <PrivateRoute path="/home-banners/section/:id">
              <BannerSection />
            </PrivateRoute>
            <PrivateRoute path="/payouts">
              <Payouts />
            </PrivateRoute>
            <PrivateRoute path="/restaurant-response">
              <RestaurantResponse />
            </PrivateRoute>
            <PrivateRoute path="/orders">
              <Orders />
            </PrivateRoute>
            <PrivateRoute path="/orderID/:id">
              <OrderID />
            </PrivateRoute>
            <PrivateRoute path="/customers">
              <Customers />
            </PrivateRoute>
            <PrivateRoute path="/customerID/:id">
              <Customer />
            </PrivateRoute>
            <PrivateRoute path="/comments">
              <Comments />
            </PrivateRoute>
            <PrivateRoute path="/products">
              <Products />
            </PrivateRoute>
            <PrivateRoute path="/productID/:id">
              <ProductID />
            </PrivateRoute>
            <PrivateRoute path="/forgot-password">
              <ForgotPassword />
            </PrivateRoute>
            <PrivateRoute path="/categories">
              <Categories />
            </PrivateRoute>
            <PrivateRoute exact path="/category-umbrellas">
              <CategoryUmbrellas />
            </PrivateRoute>
            <PrivateRoute path="/menu">
              <Menu />
            </PrivateRoute>
            <PrivateRoute path="/addMenu">
              <AddMenu />
            </PrivateRoute>
            <PrivateRoute path="/menuID/:id">
              <MenuID />
            </PrivateRoute>
            <PrivateRoute path="/categoryID/:id">
              <CategoryID />
            </PrivateRoute>
            <PrivateRoute path="/edit-category-byID">
              <EditCategoryByID />
            </PrivateRoute>
            <PrivateRoute path="/addcategory">
              <AddCategory />
            </PrivateRoute>

            <PrivateRoute path="/addproducts">
              <AddProduct />
            </PrivateRoute>
            <PrivateRoute path="/varients">
              <Variant />
            </PrivateRoute>
            <PrivateRoute path="/delivery-boys">
              <DeliveryBoys />
            </PrivateRoute>
            <PrivateRoute path="/addboy">
              <AddDeliveryBoy />
            </PrivateRoute>
            <PrivateRoute path="/deliboy/:id">
              <DeliveryBoy />
            </PrivateRoute>
            <PrivateRoute path="/managers">
              <Managers />
            </PrivateRoute>
            <PrivateRoute path="/manager/:id">
              <Manager />
            </PrivateRoute>
            <PrivateRoute path="/addmanager">
              <AddManager />
            </PrivateRoute>

            <PrivateRoute path="/offer-products">
              <ProductOffers />
            </PrivateRoute>

            <PrivateRoute path="/banners">
              <Banners />
            </PrivateRoute>
            <PrivateRoute path="/addbanner">
              <Banner />
            </PrivateRoute>
            <PrivateRoute path="/editbanner/:id/:type">
              <Banner />
            </PrivateRoute>

            <PrivateRoute path="/promocode">
              <Promocode />
            </PrivateRoute>
            <PrivateRoute path="/editpromo/:id">
              <PromocodeEdit />
            </PrivateRoute>
            <PrivateRoute path="/addpromo">
              <PromocodeAdd />
            </PrivateRoute>

            <PrivateRoute path="/settings">
              <Settings />
            </PrivateRoute>
            <PrivateRoute path="/setting/:id">
              <Settings />
            </PrivateRoute>

            {/* <PrivateRoute path="/settingsX"><SettingsX /></PrivateRoute> */}
            <PrivateRoute path="/deliveryboy-reports">
              <DeliveryboyReports />
            </PrivateRoute>
            <PrivateRoute path="/restaurant-reports">
              <RestaurantReports />
            </PrivateRoute>
            <PrivateRoute path="/notification">
              <Notification />
            </PrivateRoute>
            {/* <PrivateRoute path="/test"><Test1></Test1></PrivateRoute> */}

            <PrivateRoute path="/order-reports">
              {is_staff_only ? <Redirect to="/orders" /> : <Orderreports />}
            </PrivateRoute>
            <PrivateRoute path="/reports">
              {is_staff_only ? <Redirect to="/orders" /> : <OrderReportNew />}
            </PrivateRoute>
            <PrivateRoute path="/wallet-reports">
              <Wallet />
            </PrivateRoute>
            <PrivateRoute path="/rider-settlement">
              {is_staff_only ? <Redirect to="/orders" /> : <RiderSettlement />}
            </PrivateRoute>
            <PrivateRoute path="/restaurant-settlement">
              {is_staff_only ? <Redirect to="/orders" /> : <RestaurantSettlement />}
            </PrivateRoute>
            <PrivateRoute path="/app-updates">
              <AppUpdates />
            </PrivateRoute>

            <PrivateRoute path="/sloats">
              <Sloats />
            </PrivateRoute>
            <PrivateRoute path="/add_sloat">
              <AddSloat />
            </PrivateRoute>
            <PrivateRoute path="/delivery-slots">
              <DeliverySlots />
            </PrivateRoute>
            <PrivateRoute path="/profile">
              <Profile />
            </PrivateRoute>
            <PrivateRoute path="/order_export">
              <OrderExport />
            </PrivateRoute>
            <PrivateRoute path="/resetPassword/:id">
              <PasswordResetForShop />
            </PrivateRoute>
            <PrivateRoute path="/franchiseRequest">
              <FranchiseRequest />
            </PrivateRoute>
            <PrivateRoute path="/MobileLandingPage">
              <MobileLandingPage />
            </PrivateRoute>

            <PrivateRoute path="/test-page">
              <TestPage />
            </PrivateRoute>

            <Route component={Error404} />
          </Switch>
        </Router>
      </AppContext.Provider>
    </div>
  );
}

export default App;

function Error404() {
  return (
    <div
      style={{
        color: "black",
        height: "100vh",
        flex: 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          flex: 1,
          color: "white",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <span
          style={{
            justifyContent: "center",
            backgroundRepeat: "no-repeat",
            width: "300px",
            height: "100px",
            display: "flex",
            color: "black",
          }}
        >
          {/* backgroundImage:`url(${Image404})`, */}
          <img src={Image404} alt="Page not found" />
        </span>
        <b style={{ color: "black" }}>Page Not Found</b>

        <span style={{ color: "black" }}>
          The page you are looking for was not found.
        </span>
        <span
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "black",
          }}
        >
          Please go back to previous page or{" "}
          <a href="/" style={{ color: "green" }}>
            {" "}
            &nbsp;Go to Home
          </a>
        </span>
      </div>
    </div>
  );
}
